import React from 'react'
import Navbar from './NavBar'
import {Typography, Box} from '@mui/material'

const Page404 = ({posts}) => {
  return (
    <>
      <Navbar posts={posts} />
      <Typography variant="h1" textAlign='center' sx={{ paddingTop:'120px'}}>Page <Box as='span' sx={{color:'#00FBF4'}} variant='h1'>404</Box>  is not found</Typography>
        
    </>
  )
}

export default Page404
